import React from 'react';
import DownIcon from 'mdi-react/ChevronDownIcon';
import { Link } from 'react-router-dom';
import {
  DropdownItem, DropdownToggle, DropdownMenu, UncontrolledDropdown,
} from 'reactstrap';
import TopbarNavLink from './TopbarNavLink';

const TopbarNavHealth = () => (
  <UncontrolledDropdown className="topbar__nav-dropdown">
    <DropdownToggle className="topbar__nav-dropdown-toggle">
        <i className="fa fa-heartbeat" aria-hidden="true"/>
      <Link to="/asset_health">Health </Link>
    </DropdownToggle>
  </UncontrolledDropdown>
);


export default TopbarNavHealth;
